import chevronRightSVG from '../../assets/icons/chevron-right-sm.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const ChevronRightWhiteIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chevronRightSVG} {...props} />;
};
